import api from "@/api/apiConfig"
import {
  Post,
  Get,
  Delete,
  Put
} from './base/baseAjax'
let getGuideList = (param) => {
  return Get({
    url: api.advertManage.getGuideList,
    bodyParam: param
  })
}
let addGuide = (param) => {
  return Post({
    url: api.advertManage.addGuide,
    bodyParam: param
  })
}
let deleteGuide = (param) => {
  return Delete({
    url: api.advertManage.deleteGuide,
    UrlParam: param
  })
}
let updateGuide = (param) => {
  return Put({
    url: api.advertManage.updateGuide,
    bodyParam: param
  })
}
let getPageMapping = (param) => {
  return Get({
    url: api.advertManage.getPageMapping,
    UrlParam: param
  })
}

export default {
  getGuideList,
  addGuide,
  deleteGuide,
  updateGuide,
  getPageMapping
}


// WEBPACK FOOTER //
// ./src/services/advertManage.js